import { ipoService } from './ipoService';

const PAGE_SIZE = 100;
// Safety cap on page requests if the reported total ever keeps growing
const MAX_PAGES = 10;

/**
 * Every record of GET /api/core/ipos, page by page until the reported total.
 * The endpoint has no search, so issuer lookups match names client-side.
 */
export const fetchAllIpoRecords = async ({ pageSize = PAGE_SIZE, maxPages = MAX_PAGES } = {}) => {
  const records = [];
  let total = Infinity;
  for (let page = 1; records.length < total && page <= maxPages; page += 1) {
    const response = await ipoService.getIpos({ page, page_size: pageSize });
    if (response?.success === false) {
      throw new Error(response.error || 'Failed to fetch the IPO catalog');
    }
    const batch = Array.isArray(response?.data) ? response.data : [];
    records.push(...batch);
    total = typeof response?.total === 'number' ? response.total : records.length;
    if (!batch.length) break;
  }
  return { records, total };
};

export default fetchAllIpoRecords;
